module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Tabs/images/border.1471238c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Tabs/images/border.png
// module id = 2749
// module chunks = 11